var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#335C75"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8242 28.6368C14.701 21.2316 13.75 20.4715 13.75 17.75C13.75 14.0221 16.781 11 20.5199 11C24.2588 11 27.2898 14.0221 27.2898 17.75C27.2898 20.4715 26.3389 21.2316 21.2157 28.6368C20.8795 29.1211 20.1603 29.121 19.8242 28.6368ZM20.5199 20.5625C22.0778 20.5625 23.3407 19.3033 23.3407 17.75C23.3407 16.1967 22.0778 14.9375 20.5199 14.9375C18.962 14.9375 17.6991 16.1967 17.6991 17.75C17.6991 19.3033 18.962 20.5625 20.5199 20.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11.5 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.9026846c66ee0391c458514cae0e0240.svg";
export { ForwardRef as ReactComponent };